import { writable } from 'svelte/store';
import AssetService from '.';
export const assetStore = writable({
    assets: [],
    loading: true
});
export const loadAssets = () => {
    const assetService = new AssetService();
    assetService.fetchAll().then(response => {
        if (response) {
            assetStore.set({
                assets: response,
                loading: false
            });
        }
    });
};
